import React from "react";
import { Hourglass, Ban, PauseCircle } from "lucide-react";
import { usePrefs } from "@/contexts/PrefsContext";
import { useAuth } from "@/contexts/AuthContext";

const META = {
  pending: { icon: Hourglass, title: "pending.title", body: "pending.body" },
  rejected: { icon: Ban, title: "rejected.title", body: "rejected.body" },
  suspended: { icon: PauseCircle, title: "suspended.title", body: "suspended.body" },
};

export const PendingNotice = () => {
  const { t } = usePrefs();
  const { user } = useAuth();
  const acc = user ? user.venue_account : null;
  const status = (acc?.status || "pending") as keyof typeof META;
  const m = META[status] || META.pending;
  return (
    <div data-testid="venue-pending-notice" className="max-w-lg mx-auto mt-10 rounded-3xl border bg-card p-8 text-center space-y-4 shadow-sm">
      <div className="mx-auto h-16 w-16 rounded-3xl bg-secondary/15 text-secondary grid place-items-center">
        <m.icon className="h-8 w-8" />
      </div>
      <h1 className="font-display text-2xl font-black">{t(m.title)}</h1>
      <p className="text-muted-foreground leading-relaxed">{t(m.body)}</p>
      {acc?.status_reason && status !== "pending" && (
        <p data-testid="venue-status-reason" className="rounded-2xl bg-accent p-3 text-sm"><b>{t("status.reason")}:</b> {acc.status_reason}</p>
      )}
    </div>
  );
};

export const SuspendedBanner = () => {
  const { t } = usePrefs();
  const { user } = useAuth();
  const acc = user ? user.venue_account : null;
  return (
    <div data-testid="venue-suspended-banner" className="mb-5 rounded-2xl bg-rose-500/10 text-rose-700 dark:text-rose-300 p-4 text-sm flex gap-3">
      <PauseCircle className="h-5 w-5 shrink-0" />
      <div>
        <p className="font-bold">{t("suspended.title")}</p>
        <p>{t("suspended.body")}{acc?.status_reason ? ` — ${t("status.reason")}: ${acc.status_reason}` : ""}</p>
      </div>
    </div>
  );
};
